import React from 'react';

import Show from 'components/Show';
import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';

import GradeTabs from 'containers/Parent/Marks/Read/Tabs/Grades';
// import ViewTabs from 'containers/Parent/Marks/Read/Tabs/Views';

import Summary from 'containers/Parent/Marks/Summary';
// import Report from 'containers/Parent/Marks/Report';
// import Certificate from 'containers/Parent/Marks/Certificate';

const Child = ({ child }) => {
	return (
		<div key={child.id} className="p-4 bg-white dark:bg-neutral-800 rounded-lg">
			<div className="mb-4 flex space-x-2 items-center">
				<Avatar
					alt={child.fullName}
					src={child.avatar}
				/>

				<Title
					title={child.fullName}
					className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
				/>
			</div>

			{/* Grade tabs */}
			<GradeTabs childId={child.id} />

			{/* View tabs */}
			{/* <ViewTabs childId={child.id} /> */}

			{/* Mark summary */}
			<Show if={child.view === 'summary'}>
				<Summary childId={child.id} />
			</Show>

			{/* Mark report */}
			{/* <Show if={child.view === 'report'}> */}
			{/* <Report /> */}
			{/* </Show> */}

			{/* Mark certificate */}
			{/* <Show if={child.view === 'certificate'}> */}
			{/* <Certificate /> */}
			{/* </Show> */}
		</div>
	);
};

export default Child;